// @flow
import { NAVIGATION_TABS } from 'Client/cms/toolkit/constants';
import { NavigationTabsLine } from 'Components/lines/navigation-tabs-line/NavigationTabsLine.jsx';
import { navigationTabsResolver } from './navigationTabs.resolver';

export const navigationTabsDescriptor = {
  name: NAVIGATION_TABS,
  component: NavigationTabsLine,
  resolve: navigationTabsResolver.resolve,
};
